var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeriecenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.961,4.962,8.054,2.021a.434.434,0,0,0-.448,0L2.7,4.962a.437.437,0,0,0,.449.749L7.83,2.905l4.682,2.806a.437.437,0,1,0,.449-.749Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,11.509h-.47a.427.427,0,0,0,.025-.124v-1.9a.437.437,0,0,0-.874,0V10.2H4.846V8.558a.437.437,0,1,0-.873,0v2.831a.441.441,0,0,0,.024.12H3.575a.328.328,0,0,0,0,.656H12a.328.328,0,0,0,0-.656Zm-7.158-.12v-.314h5.839v.31a.4.4,0,0,0,.026.124H4.822A.406.406,0,0,0,4.846,11.389Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.049,9.214a.627.627,0,1,0-.627-.627A.627.627,0,0,0,6.049,9.214Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.168,9.66a.328.328,0,0,0,.328.327H7.015l.01,0h3.039a.192.192,0,0,0,.192-.192A1.192,1.192,0,0,0,9.064,8.6H6.994a.192.192,0,0,0-.192.192v.539H5.5A.328.328,0,0,0,5.168,9.66Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeriecenter);
export default __webpack_public_path__ + "static/media/FERIECENTER.279512e94d399803604fb5922728a375.svg";
export { ForwardRef as ReactComponent };